/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThemesRouteImport } from './routes/themes'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminFeesRouteImport } from './routes/admin.fees'
import { Route as AdminCompaniesRouteImport } from './routes/admin.companies'
import { Route as AdminAuditLogRouteImport } from './routes/admin.audit-log'

const ThemesRoute = ThemesRouteImport.update({
  id: '/themes',
  path: '/themes',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeesRoute = AdminFeesRouteImport.update({
  id: '/admin/fees',
  path: '/admin/fees',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCompaniesRoute = AdminCompaniesRouteImport.update({
  id: '/admin/companies',
  path: '/admin/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/themes': typeof ThemesRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/fees': typeof AdminFeesRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/themes': typeof ThemesRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/fees': typeof AdminFeesRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/themes': typeof ThemesRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/companies': typeof AdminCompaniesRoute
  '/admin/fees': typeof AdminFeesRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/themes'
    | '/admin/audit-log'
    | '/admin/companies'
    | '/admin/fees'
    | '/admin/users'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/themes'
    | '/admin/audit-log'
    | '/admin/companies'
    | '/admin/fees'
    | '/admin/users'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/themes'
    | '/admin/audit-log'
    | '/admin/companies'
    | '/admin/fees'
    | '/admin/users'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ThemesRoute: typeof ThemesRoute
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminCompaniesRoute: typeof AdminCompaniesRoute
  AdminFeesRoute: typeof AdminFeesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/themes': {
      id: '/themes'
      path: '/themes'
      fullPath: '/themes'
      preLoaderRoute: typeof ThemesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/fees': {
      id: '/admin/fees'
      path: '/admin/fees'
      fullPath: '/admin/fees'
      preLoaderRoute: typeof AdminFeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/companies': {
      id: '/admin/companies'
      path: '/admin/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ThemesRoute: ThemesRoute,
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminCompaniesRoute: AdminCompaniesRoute,
  AdminFeesRoute: AdminFeesRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
